import { whereConnectionStatusDefault } from '@vrplatform/ui-common';
import { type Query, useQuery } from '../graphql';
import { useTeam } from '../hooks/team';

export const STORYBOOK_PROPERTY_MANAGEMENT_CONNECTIONS_QUERY_KEY =
  'onboarding-property-management-connections';

export type PropertyManagementConnection = {
  appId: string;
  logoUrl: string | null | undefined;
  name: string;
  type: string;
  category: string | undefined;
  id: string;
};

export const getPropertyManagementConnections = (
  q: Query,
  args: { teamId: string },
  opts?: {
    limit?: number;
  }
): PropertyManagementConnection[] => {
  return q
    .connection({
      where: {
        status: whereConnectionStatusDefault,
        tenantId: { _eq: args.teamId },
        app: { category: { _eq: 'propertyManagementSystem' } },
      },
      order_by: [{ appId: 'asc_nulls_first' }],
      limit: opts?.limit,
    })
    .map((connection) => ({
      appId: connection.appId,
      logoUrl:
        connection.icon || connection.app.iconRound || connection.app.icon,
      name: connection.app.name,
      type: connection.app.type,
      category: connection.app.category,
      id: connection.id,
    }));
};

export function usePropertyManagementConnectionsQuery(
  opts?: Parameters<typeof getPropertyManagementConnections>[2]
) {
  const [{ id: teamId }] = useTeam();

  return useQuery(
    (q, { opts: queryOpts, ...args }) =>
      getPropertyManagementConnections(q, args, queryOpts),
    {
      keepPreviousData: true,
      storybookQueryKey: STORYBOOK_PROPERTY_MANAGEMENT_CONNECTIONS_QUERY_KEY,
      variables: {
        teamId,
        opts,
      },
      queryKey: ['connections'],
    }
  );
}
